// import React, { useState, useEffect } from "react";
// import { X } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { toast } from "react-hot-toast";

// const AddressFormModal = ({ isOpen, onClose, onSuccess, initialData = null }) => {
//   const [formData, setFormData] = useState({
//     name: "", phone: "", flat: "", area: "", city: "", state: "", pincode: ""
//   });

//   useEffect(() => {
//     if (initialData) setFormData(initialData);
//     else setFormData({ name: "", phone: "", flat: "", area: "", city: "", state: "", pincode: "" });
//   }, [initialData, isOpen]);

//   const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const apiConfig = initialData 
//         ? { ...SummaryApi.updateAddress, url: SummaryApi.updateAddress.url(initialData._id) }
//         : SummaryApi.addAddress;
      
//       const res = await api({ ...apiConfig, data: formData });
//       if (res.data.success) {
//         toast.success(initialData ? "Address Updated" : "Address Added");
//         onSuccess();
//         onClose();
//       }
//     } catch (err) { toast.error("Failed to save address"); }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
//       <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl animate-in zoom-in duration-200">
//         <div className="p-6 border-b flex justify-between items-center">
//           <h2 className="font-bold text-gray-800">{initialData ? "Edit Address" : "Add New Address"}</h2>
//           <button onClick={onClose} className="text-gray-400 hover:text-black"><X size={20}/></button>
//         </div>
//         <form onSubmit={handleSubmit} className="p-6 space-y-4">
//           <input name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" className="w-full border border-gray-200 rounded-lg p-3 text-sm outline-none focus:border-blue-500" required />
//           <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="w-full border border-gray-200 rounded-lg p-3 text-sm outline-none focus:border-blue-500" required />
//           <div className="grid grid-cols-2 gap-4">
//             <input name="flat" value={formData.flat} onChange={handleChange} placeholder="Flat/Plot No" className="border border-gray-200 rounded-lg p-3 text-sm outline-none" required />
//             <input name="pincode" value={formData.pincode} onChange={handleChange} placeholder="Pincode" className="border border-gray-200 rounded-lg p-3 text-sm outline-none" required />
//           </div>
//           <input name="area" value={formData.area} onChange={handleChange} placeholder="Area / Street" className="w-full border border-gray-200 rounded-lg p-3 text-sm outline-none" required />
//           <div className="grid grid-cols-2 gap-4">
//             <input name="city" value={formData.city} onChange={handleChange} placeholder="City" className="border border-gray-200 rounded-lg p-3 text-sm outline-none" required />
//             <input name="state" value={formData.state} onChange={handleChange} placeholder="State" className="border border-gray-200 rounded-lg p-3 text-sm outline-none" required />
//           </div>
//           <button type="submit" className="w-full bg-[#3B82F6] text-white py-3 rounded-xl font-bold hover:bg-blue-600 transition-all">SAVE ADDRESS</button>
//         </form>
//       </div>
//     </div>
//   );
// };
// export default AddressFormModal;

// import React, { useState, useEffect } from "react";
// import { X } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { toast } from "react-hot-toast";

// const AddressFormModal = ({ isOpen, onClose, onSuccess, initialData = null }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     flat: "",
//     area: "",
//     city: "",
//     state: "",
//     pincode: "",
//   });
//   const [loading, setLoading] = useState(false);

//   // Edit செய்யும் போது பழைய டேட்டாவை உள்ளீடு செய்கிறது
//   useEffect(() => {
//     if (initialData) {
//       setFormData({
//         name: initialData.name || "",
//         phone: initialData.phone || "",
//         flat: initialData.flat || "",
//         area: initialData.area || "",
//         city: initialData.city || "",
//         state: initialData.state || "",
//         pincode: initialData.pincode || "",
//       });
//     } else {
//       setFormData({ name: "", phone: "", flat: "", area: "", city: "", state: "", pincode: "" });
//     }
//   }, [initialData, isOpen]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const apiConfig = initialData
//         ? { ...SummaryApi.updateAddress, url: SummaryApi.updateAddress.url(initialData._id) }
//         : SummaryApi.addAddress;

//       const res = await api({
//         url: apiConfig.url,
//         method: apiConfig.method,
//         data: formData,
//       });

//       if (res.data.success) {
//         toast.success(initialData ? "Address Updated!" : "Address Added!");
//         onSuccess(); // முகவரி பட்டியலை புதுப்பிக்க
//         onClose();   // Modal-ஐ மூட
//       }
//     } catch (err) {
//       toast.error("Failed to save address details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[3000] flex items-center justify-center p-4">
//       <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl animate-in zoom-in duration-200 overflow-hidden">
//         <div className="p-6 bg-[#3B82F6] text-white flex justify-between items-center">
//           <h2 className="font-bold text-lg">{initialData ? "Edit Address" : "Add New Address"}</h2>
//           <button onClick={onClose} className="hover:bg-white/20 p-1 rounded-full"><X size={24} /></button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-8 space-y-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <input name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" className="w-full border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//             <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="w-full border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <input name="flat" value={formData.flat} onChange={handleChange} placeholder="Flat / Plot No" className="border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//             <input name="pincode" value={formData.pincode} onChange={handleChange} placeholder="Pincode" className="border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//           </div>
//           <input name="area" value={formData.area} onChange={handleChange} placeholder="Area / Street / Colony" className="w-full border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//           <div className="grid grid-cols-2 gap-4">
//             <input name="city" value={formData.city} onChange={handleChange} placeholder="City" className="border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//             <input name="state" value={formData.state} onChange={handleChange} placeholder="State" className="border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500" required />
//           </div>

//           <div className="pt-4 flex gap-3">
//             <button type="button" onClick={onClose} className="flex-1 border border-gray-200 py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-50">CANCEL</button>
//             <button type="submit" disabled={loading} className="flex-1 bg-[#3B82F6] text-white py-3 rounded-xl font-bold hover:bg-blue-600 disabled:bg-gray-400">
//               {loading ? "SAVING..." : "SAVE ADDRESS"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddressFormModal;

import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { toast } from "react-hot-toast";

const AddressFormModal = ({ isOpen, onClose, onSuccess, initialData = null }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    country: "India",
    pincode: "",
    flat: "",
    area: "",
    landmark: "",
    city: "",
    state: "",
    type: "home",
    isDefault: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        phone: initialData.phone || "",
        country: initialData.country || "India",
        pincode: initialData.pincode || "",
        flat: initialData.flat || "",
        area: initialData.area || "",
        landmark: initialData.landmark || "",
        city: initialData.city || "",
        state: initialData.state || "",
        type: initialData.type || "home",
        isDefault: initialData.isDefault || false,
      });
    } else {
      setFormData({
        name: "", phone: "", country: "India", pincode: "",
        flat: "", area: "", landmark: "", city: "", state: "",
        type: "home", isDefault: false
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiConfig = initialData
        ? { ...SummaryApi.updateAddress, url: SummaryApi.updateAddress.url(initialData._id) }
        : SummaryApi.addAddress;

      const res = await api({
        url: apiConfig.url,
        method: apiConfig.method,
        data: formData,
      });

      if (res.data.success) {
        toast.success(initialData ? "Address Updated!" : "Address Added!");
        onSuccess();
        onClose();
      }
    } catch (err) {
      toast.error("Failed to save address.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const labelClass = "block text-[11px] font-black text-gray-400 mb-1 uppercase tracking-widest";
  const inputClass = "w-full border border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500 bg-[#F9FAFB]";

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[3000] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-2xl rounded-[2.5rem] shadow-2xl animate-in zoom-in duration-200 overflow-hidden">
        <div className="p-6 bg-[#3B82F6] text-white flex justify-between items-center">
          <h2 className="font-bold text-lg">{initialData ? "Edit Address" : "Add New Address"}</h2>
          <button onClick={onClose} className="hover:bg-white/20 p-1 rounded-full"><X size={24} /></button>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-4 max-h-[75vh] overflow-y-auto custom-scrollbar">
          {/* Row 1: Name & Phone */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={labelClass}>Full Name</label>
              <input name="name" value={formData.name} onChange={handleChange} placeholder="Enter name" className={inputClass} required />
            </div>
            <div>
              <label className={labelClass}>Mobile Number</label>
              <input name="phone" value={formData.phone} onChange={handleChange} placeholder="10-digit number" className={inputClass} required />
            </div>
          </div>

          {/* Row 2: Country & Pincode */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={labelClass}>Country / Region</label>
              <input name="country" value={formData.country} onChange={handleChange} className={inputClass} required />
            </div>
            <div>
              <label className={labelClass}>Pincode</label>
              <input name="pincode" value={formData.pincode} onChange={handleChange} placeholder="6-digit pincode" className={inputClass} required />
            </div>
          </div>

          {/* Row 3: Flat info */}
          <div>
            <label className={labelClass}>Flat, House no, Building, Apartment</label>
            <input name="flat" value={formData.flat} onChange={handleChange} className={inputClass} required />
          </div>

          {/* Row 4: Area info */}
          <div>
            <label className={labelClass}>Area, Street, Village</label>
            <input name="area" value={formData.area} onChange={handleChange} className={inputClass} required />
          </div>

          {/* Row 5: Landmark */}
          <div>
            <label className={labelClass}>Landmark (Optional)</label>
            <input name="landmark" value={formData.landmark} onChange={handleChange} placeholder="E.g. Near Apollo Hospital" className={inputClass} />
          </div>

          {/* Row 6: City & State */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={labelClass}>Town / City</label>
              <input name="city" value={formData.city} onChange={handleChange} className={inputClass} required />
            </div>
            <div>
              <label className={labelClass}>State</label>
              <input name="state" value={formData.state} onChange={handleChange} className={inputClass} required />
            </div>
          </div>

          {/* Row 7: Type & Default */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pt-2">
            <div className="flex-1">
              <label className={labelClass}>Address Type (Home / Office)</label>
              <select name="type" value={formData.type} onChange={handleChange} className={inputClass}>
                <option value="home">Home</option>
                <option value="office">Office</option>
                <option value="other">Other</option>
              </select>
            </div>
            <label className="flex items-center gap-2 cursor-pointer pt-4">
              <input type="checkbox" name="isDefault" checked={formData.isDefault} onChange={handleChange} className="w-5 h-5 accent-blue-600" />
              <span className="text-sm font-bold text-gray-500">Make Default</span>
            </label>
          </div>

          <div className="pt-6 flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 border border-gray-200 py-4 rounded-2xl font-black text-gray-400 uppercase tracking-widest text-xs">Cancel</button>
            <button type="submit" disabled={loading} className="flex-1 bg-[#3B82F6] text-white py-4 rounded-2xl font-black shadow-lg hover:bg-blue-600 uppercase tracking-widest text-xs">
              {loading ? "Saving..." : "Save Address"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddressFormModal;